module.exports = __webpack_public_path__ + "static/media/Sarabun-Medium.c0ee849b.ttf";